// extracted by mini-css-extract-plugin
export default {"ReportIndex":"ReportIndex--GtVtF"};